export const Colors = {
    NAV_COL: "#252829",
    NAV_ERROR_COL: "#CC0C39",
    NAV_WARN_COL: "#DCB700"
};


// WEBPACK FOOTER //
// ./src/components/utils/Colors.js